import Vue from 'vue'
import VueRouter from 'vue-router'
// 配置router路由
// import store from '../store'

Vue.use(VueRouter);
import Home from '../../pages/Home.vue'
import Index from '../../pages/Index.vue'
import Generate from '../../pages/Generate.vue'
import Record from '../../pages/Record.vue'
import Report from '../../pages/Report.vue'
import ReportShare from '../../pages/ReportShare.vue'

import { DOM } from '../utils';
import { WEIXIN } from '../weixin';

/**
 * 定义路由
 */
var route =  new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/home',
            component: Home,
            meta: {
                index: 0
            }
        },
        {
            path: '/index',
            component: Index,
            meta: {
                index: 0
            }
        },
        {
            path: '/generate',
            component: Generate,
            meta: {
                index: 0
            }
        },
        {
            path: '/record',
            component: Record,
            meta: {
                index: 0
            }
        },
        {
            path: '/report',
            component: Report,
            meta: {
                index: 0
            }
        },
        {
            path: '/reportshare',
            component: ReportShare,
            meta: {
                index: 0
            }
        }
    ]
});

// route.beforeEach((to, from, next) => {
//     next()
//     var curPath = to.path;
//     console.log('beforeEach--------', curPath)
//     // 动态配置微信分享
//     setTimeout(() => {
//         WEIXIN.initConfigShare(curPath);
//     }, 1000);
// });

export default route;